module.exports = __webpack_public_path__ + "static/FontAwesome5_Solid-b70cea0339374107969eb53e5b1f603f.ttf";